import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton, OFFER_ID } from './CtaButton';
import { PRICE, PRICE_PLN } from '../data/valueStack';

/** Mobile-only bar that appears after the hero and hides while the offer is on screen. */
export function StickyBuyBar() {
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const offer = document.getElementById(OFFER_ID);
    const observer = offer ? new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
      threshold: 0.05
    }) : null;
    if (offer && observer) observer.observe(offer);
    return () => {
      window.removeEventListener('scroll', onScroll);
      observer?.disconnect();
    };
  }, []);
  const isVisible = pastHero && !offerVisible;
  return <AnimatePresence data-id="element-227" data-mp="29g0vdbcyt2v4">
      {isVisible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink px-4 pb-4 pt-3 sm:hidden" data-id="element-228" data-mp="2edu3wb1qq8yk">
          <div className="flex items-center justify-between gap-3" data-id="element-229" data-mp="2s60gxo9ljzts">
            <p className="leading-none" data-id="element-230" data-mp="2x4bqryzw6ac0">
              <span className="font-display text-3xl font-extrabold text-gold" data-id="element-231" data-mp="2x38zvr2kk7w3">{PRICE}</span>
              <span className="ml-1.5 text-xs text-copy-light" data-id="element-232" data-mp="324gadxw3jl6g">{PRICE_PLN}</span>
            </p>
            <CtaButton size="md" data-id="element-233" data-mp="3659wclpzapwp">Zobacz ofertę</CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}